import { getQuery } from "./PaymentgatewayWrapper.js";

const getInvoice = async (customer_id) => {
  try {
    const data = JSON.stringify({
      query: `query GetInvoice($customerId: String!) {
        getInvoice(customer_id: $customerId) {
          isSuccessful
          message
          resultObject
        }
      }`,
      variables: {
        customerId: customer_id
      }
    });
    const response = await getQuery(data);
    return response?.getInvoice;
  } catch (error) {
    console.log(error);
  }
};

const transactionHistory = async (customer_id, start_date, end_date) => {
  if (start_date === end_date) {
    end_date = end_date + 86399;
  }
  try {
    const data = JSON.stringify({
      query: `query TransactionHistory($customerId: String!, $input: TransactionHistoryInput) {
        transactionHistory(customer_id: $customerId, input: $input) {
          isSuccessful
          message
          resultObject
        }
      }`,
      variables: {
        customerId: customer_id,
        input: {
          end_date: end_date,
          start_date: start_date
        }
      }
    });
    const response = await getQuery(data);
    return response?.transactionHistory;
  } catch (error) {
    console.log(error);
  }
};

const invoices = async () => {
  try {
    const data = JSON.stringify({
      query: `query Query {
        invoice {
          isSuccessful
          message
          resultObject
        }
      }`
    });
    const response = await getQuery(data);
    return response?.invoice;
  } catch (error) {
    console.log(error);
  }
};

export { getInvoice, transactionHistory, invoices };
